import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';
import {StylesService} from '../diagram-render/styles/styles.service';
import {map} from 'rxjs/operators';
import {MapService} from '../core/map/map.service';
import {DiagramTypeConfigService} from '../core/services/diagram-type-config.service';
import {ServerStyleCollection} from '../diagram-render/styles/styles.model';
import {DiagramMetaInterface} from '../diagram-data/diagram-meta.interface';

@Injectable()
export class NoUiResolve {
  constructor(
    private http: HttpClient,
    private stylesSvc: StylesService,
    private mapService: MapService,
    private diagramTypeConfigService: DiagramTypeConfigService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const {base, path, stylePath, authToken} = route.queryParams;
    const dataUrl = `${base}${path}.json?auth=${authToken}`;
    const styleUrl = `${base}${stylePath}.json?auth=${authToken}`;

    return forkJoin(this.http.get(dataUrl), this.http.get(styleUrl)).pipe(
      map(<T extends DiagramMetaInterface>([json, styles]: [T, ServerStyleCollection]) => {
        this.diagramTypeConfigService.setDiagramConfig(json);
        this.stylesSvc.setPrimary(styles);
        this.mapService.setup(json as any);

        return json;
      })
    );
  }
}
